import Colors from '~/client/src/shared/theme.module.scss'

// Single source of truth for the markup editor's handle visuals, shared by the
// GL layers (MarkupDrawController) and the HTML overlay chrome (MarkupEditor,
// MarkupTextBox). Taxonomy: path VERTICES are circles, RESIZE handles are
// squares, MIDPOINTS are a smaller inverted dot, ROTATE is an offset circle
// with a rotate icon and a stem to the bbox.

// GL paint needs plain-hex tokens; var()-based ones (e.g. neutral100 =
// hsla(.. var(--tone100) ..)) fail mapbox's static color parser and drop the layer.
export const HANDLE_ACCENT = Colors.brandBlue
export const HANDLE_FILL = Colors.mapWhite

export const VERTEX_RADIUS = 5
export const VERTEX_STROKE_WIDTH = 2

/** Insert-a-vertex affordance (smaller than vertices). */
export const MIDPOINT_RADIUS = 3
export const MIDPOINT_STROKE_WIDTH = 1

// touch-none: claim a touch-drag that starts on a handle for the gesture (rotate/
// resize) instead of letting the browser pan the map under it — without it, touch
// pointermove events stop firing mid-drag (freeze) and the release jumps.
/** A circle, like path vertices — the one primitive the GL canvas renders
 * screen-constant and synchronously. */
export const RESIZE_HANDLE_CLASS =
  'tw:size-2.5 tw:touch-none tw:rounded-full tw:border-2 tw:border-primary tw:bg-white'

export const ROTATE_HANDLE_CLASS =
  'tw:flex tw:size-4 tw:touch-none tw:items-center tw:justify-center tw:rounded-full tw:border-2 tw:border-primary tw:bg-white'
